import { UserActionTypes,UserDetailsTypes,UserDetails, User, CREATE_USER, USER_DETAILS } from "./types";


export function setUser(user: User): UserActionTypes {
    return {
      type: CREATE_USER,
      data: user
    }
  }

  export function saveDetails(userDetails:UserDetails):UserDetailsTypes{
    return {
      type: USER_DETAILS,
      data: userDetails
    }

  }